/* eslint-disable operator-assignment */
/* eslint-disable vars-on-top */

import { CARD_TYPE } from '../configs/payment.config';

// luhn算法
export function luhnCheck(bankno) {
  var lastNum = bankno.substr(bankno.length - 1, 1); // 取出最后一位（与luhn进行比较）

  var first15Num = bankno.substr(0, bankno.length - 1); // 前15或18位
  var newArr = new Array();
  for (var i = first15Num.length - 1; i > -1; i--) {
    // 前15或18位倒序存进数组
    newArr.push(first15Num.substr(i, 1));
  }
  var arrJiShu = new Array(); // 奇数位*2的积 <9
  var arrJiShu2 = new Array(); // 奇数位*2的积 >9

  var arrOuShu = new Array(); // 偶数位数组
  for (var j = 0; j < newArr.length; j++) {
    if ((j + 1) % 2 == 1) {
      // 奇数位
      if (parseInt(newArr[j]) * 2 < 9) arrJiShu.push(parseInt(newArr[j]) * 2);
      else arrJiShu2.push(parseInt(newArr[j]) * 2);
    } // 偶数位
    else arrOuShu.push(newArr[j]);
  }

  var jishu_child1 = new Array(); // 奇数位*2 >9 的分割之后的数组个位数
  var jishu_child2 = new Array(); // 奇数位*2 >9 的分割之后的数组十位数
  for (var h = 0; h < arrJiShu2.length; h++) {
    jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
    jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
  }

  var sumJiShu = 0; // 奇数位*2 < 9 的数组之和
  var sumOuShu = 0; // 偶数位数组之和
  var sumJiShuChild1 = 0; // 奇数位*2 >9 的分割之后的数组个位数之和
  var sumJiShuChild2 = 0; // 奇数位*2 >9 的分割之后的数组十位数之和
  var sumTotal = 0;
  for (var m = 0; m < arrJiShu.length; m++) {
    sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
  }

  for (var n = 0; n < arrOuShu.length; n++) {
    sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
  }

  for (var p = 0; p < jishu_child1.length; p++) {
    sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p]);
    sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p]);
  }
  // 计算总和
  sumTotal = parseInt(sumJiShu) + parseInt(sumOuShu) + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2);

  // 计算luhn值
  var k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10;
  var luhn = 10 - k;

  if (lastNum == luhn) {
    return true;
  } else {
    return false;
  }
}

// 匹配卡种
export function matchCard() {
  var card = document.getElementById('card_number').value.replace(/\s/g, '');

  // 卡种正则表达式
  var rule = new Array();

  rule[CARD_TYPE['visa']] = new RegExp('^4\\d{15}$');
  rule[CARD_TYPE['mastercard']] = new RegExp(
    '^(5[1-5][\\d]{2}|222[1-9]|22[3-9][\\d]|2[3-6][\\d]{2}|27[0-1][\\d]|2720)\\d{12}$'
  );
  rule[CARD_TYPE['JCB']] = new RegExp('^35(28|29|([3-8][\\d]))\\d{12}$');
  rule[CARD_TYPE['AE']] = new RegExp('^3[47]\\d{13}$');
  rule[CARD_TYPE['dinersclubs']] = new RegExp('^36\\d{12}|3(?:0[0-5]|[68][0-9])[0-9]{11}$');
  rule[CARD_TYPE['discover']] = new RegExp('^6(?:011|5\\d{2})\\d{12}$');
  rule[CARD_TYPE['unionpay']] = new RegExp('^62\\d{14,17}$');
  rule[CARD_TYPE['maestro']] = new RegExp('^(50|(5[6-9])|(6[\\d]))\\d{10,17}$');

  // 以下卡种商城不支持，不支持的卡种获取pk会报错
  rule['aura'] = new RegExp('^5\\d{18}$');
  rule['hipercard'] = new RegExp('^(?:606282|637095|637568)\\d{10}|38\\d{14,17}$');
  rule['elo'] = new RegExp(
    '^(?:50670[7-8]|506715|50671[7-9]|50672[0-1]|50672[4-9]|50673[0-3]|506739|50674[0-8]|50675[0-3]|50677[4-8]|50900[0-9]|50901[3-9]|50902[0-9]|50903[1-9]|50904[0-9]|50905[0-9]|50906[0-4]|50906[6-9]|50907[0-2]|50907[4-5]|636368|636297|504175|438935|40117[8-9]|45763[1-2]|457393|431274|50907[6-9]|50908[0-9]|627780)[0-9]*$'
  );
  rule['rupay'] = new RegExp(
    '^(508[5-9][0-9]{12})|(6069[8-9][0-9]{11})|(607[0-8][0-9]{12})|(6079[0-8][0-9]{11})|(608[0-5][0-9]{12})|(6521[5-9][0-9]{11})|(652[2-9][0-9]{12})|(6530[0-9]{12})|(6531[0-4][0-9]{11})$'
  );

  var card_type = '';

  for (var i in rule) {
    if (rule[i].test(card)) {
      card_type = i;
      break;
    }
  }

  // 如果是AE卡，CVV长度改成4位
  if (card_type != '') {
    if (card_type == 'ae') {
      document.getElementById('card_secureCode').maxLength = 4;
      document.getElementById('card_secureCode').value = document.getElementById('card_secureCode').value.substr(0, 4);
    } else {
      document.getElementById('card_secureCode').maxLength = 3;
      document.getElementById('card_secureCode').value = document.getElementById('card_secureCode').value.substr(0, 3);
    }
  }

  // 检查luhn算法
  if (luhnCheck(card) && card != '') {
    document.getElementById('card_luhn_pass').value = '1';
  } else {
    document.getElementById('card_luhn_pass').value = '';
  }

  // 卡种
  document.getElementById('card_type').value = card_type;

  // 检查安全码
  var secureCode = document.getElementById('card_secureCode').value;

  // 正则表达式
  var cvv = new RegExp('^\\d{3}$');
  var cvv2 = new RegExp('^\\d{4}$');

  if (card_type == 'ae') {
    if (cvv2.test(secureCode)) {
      document.getElementById('card_secureCode_pass').value = '1';
    } else {
      document.getElementById('card_secureCode_pass').value = '';
    }
  } else {
    if (cvv.test(secureCode)) {
      document.getElementById('card_secureCode_pass').value = '1';
    } else {
      document.getElementById('card_secureCode_pass').value = '';
    }
  }
}

// 检查日期
export function checkDate() {
  var month = document.getElementById('card_month').value;
  var year = document.getElementById('card_year').value;

  // 正则表达式
  var month_rule = new RegExp('^\\d{2}$');
  var year_rule = new RegExp('^\\d{4}$');

  if (month != '' && year != '') {
    if (month_rule.test(month) && year_rule.test(year) && month >= 1 && month <= 12) {
      if (document.getElementById('card_year').value.length == 2) {
        year = '20' + year;
      }

      // 当前日期
      var NowDate = new Date();
      var nowyear = NowDate.getFullYear();
      var nowmonth = NowDate.getMonth() + 1;

      nowmonth = nowmonth < 10 ? '0' + nowmonth : nowmonth;
      var today = nowyear.toString() + nowmonth.toString();

      // 选择日期
      var selectday = year.toString() + month.toString();

      // 选择日期是否大于当前日期
      if (selectday >= today) {
        document.getElementById('card_date_pass').value = '1';
      } else {
        document.getElementById('card_date_pass').value = '';
      }
    } else {
      document.getElementById('card_date_pass').value = '';
    }
  } else {
    document.getElementById('card_date_pass').value = '';
  }
}

// 检查安全码
export function checkSecureCode() {
  matchCard();

  var secureCode = document.getElementById('card_secureCode').value;

  // 正则表达式
  var cvv = new RegExp('^\\d{3}$');
  var cvv2 = new RegExp('^\\d{4}$');

  // 卡种
  var card_type = document.getElementById('card_type').value;

  if (card_type == 'ae') {
    if (cvv2.test(secureCode)) {
      document.getElementById('card_secureCode_pass').value = '1';
    } else {
      document.getElementById('card_secureCode_pass').value = '';
    }
  } else {
    if (cvv.test(secureCode)) {
      document.getElementById('card_secureCode_pass').value = '1';
    } else {
      document.getElementById('card_secureCode_pass').value = '';
    }
  }
}
